/* eslint-disable import/first */
require('dotenv').config();

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import bus from './plugins/bus';
import i18n from './plugins/i18n';
import './plugins/bootstrap';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  bus,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
